var utils = require('../../utils')
export default {
  name: 'shop-edit-list',
  created () {
    var ssShopName = window.sessionStorage.getItem('sel-shopName')
    if (!!ssShopName) {
        this.shopName = ssShopName
        this.search(false)
    } else if (this.$store.getters.canManage) {
        this.shopId = this.$store.getters.currentShopID
        this.$store.dispatch('SHOP_LIST_SEARCH')
    } else {
      this.$store.dispatch('CANNOT_USE')
    }
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      shopId: null,
      shopName: null
    }
  },
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove()
    next()
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    shops () {
      return this.$store.getters.shops
    },
    nextPage () {
      return this.$store.getters.shopsNextPage
    },
    loading() {
      return this.$store.getters.apiLoading
    }
  },
  methods: {
    setCurrentShopId: function (shopId) {
      this.$store.dispatch('CHANGE_SHOP', {shopId: shopId})
      this.shopId = shopId
      this.$router.push('/')
    },
    search: function (readMore) {
      var url = null
      var loadparams = true
      if (readMore) {
        url = this.$store.getters.shopsNextPage
        loadparams = 'block'
      }
      var data = {'shop_name': this.shopName}
      if (!!this.shopName) {
          window.sessionStorage.setItem('sel-shopName', this.shopName)
      } else {
          window.sessionStorage.removeItem('sel-shopName')
      }
      this.$store.dispatch('SHOP_LIST_SEARCH', {url: url, data: data, loadparams: loadparams})
      return false
    },
    goShop: function (shopId) {
      this.$router.push({ path: '/shops/' + shopId + '/edit' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-edit-list.js